import {
  CatalystInsightFilterRequest,
  CatalystInsightFilterResponse,
  catalystInsights,
  DetailedCatalystInsight,
} from '@api';
import { apiFetch, wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const getCatalystInsightList = (
  payload: CatalystInsightFilterRequest
) => {
  const { path, schema } = catalystInsights.postCatalystInsightFilter;

  const cleanedPayload = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value !== undefined)
  ) as CatalystInsightFilterRequest;

  return wretchRequest<CatalystInsightFilterResponse>(path, {
    method: 'post',
    body: cleanedPayload,
    schema,
  });
};

export const getCatalystInsightListForChart = async (
  payload: CatalystInsightFilterRequest
) => {
  const { path, schema } = catalystInsights.postCatalystInsightFilter;

  const cleanedPayload = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value !== undefined)
  ) as CatalystInsightFilterRequest;

  return await apiFetch<CatalystInsightFilterResponse>(path, {
    method: 'post',
    body: cleanedPayload,
    schema,
  });
};

export const getCatalystInsightDetails = (insightId: string) => {
  const { path, schema } = catalystInsights.getCatalystInsight;
  return wretchRequest<DetailedCatalystInsight>(path(insightId), {
    schema,
  });
};
